<div class="container-fluid non-transparent-header px-0">
    <uikit-breadcrumb *ngIf="showBreadcrumb" [items]="breadcrumbItems"></uikit-breadcrumb>
    <div class="row g-0">
        <div class="author text-center w-100 q-page-header" 
            *ngIf="isDesktop && queuesForSingleUser && selectedUserName">
            <div class="q-page-header-inner">
                <h2 class="card-title q-page-header-title mt-3"> {{ selectedUserName }} </h2>
                <span class="w-80 underline-text-dark"></span>
            </div>
        </div>
        <app-filters class="w-100 always-collapsible-filter card card-plain mb-0 p-0" [filters]="filters" (valueChange)="onFilterValueChange()" 
        [filtered]="filtered" [isAlwaysCollapsible]="true" [retainValues]="config.filtersValueRetain || false" [filterId]="filterId"
        *ngIf="viewTableComponent && filterRolesLoaded">
        </app-filters>
        <div class="mt-2 w-100 q-page-container card card-plain mb-0 p-0">
            <app-view-table [config]="config"></app-view-table>
        </div>
    </div>
</div>